export default "__VITE_ASSET__81e6ec46__"